"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./AIApi"), exports);
__exportStar(require("./AccountDeletionRequestsApi"), exports);
__exportStar(require("./AdminApi"), exports);
__exportStar(require("./AdminAlertsApi"), exports);
__exportStar(require("./AdminContentApi"), exports);
__exportStar(require("./AdminHighlightSearchPatternsApi"), exports);
__exportStar(require("./AdminHighlightSourcesApi"), exports);
__exportStar(require("./AdminLeagueHighlightSearchPatternApi"), exports);
__exportStar(require("./AdminLeaguePlatformMappingsApi"), exports);
__exportStar(require("./AdminListingURLsApi"), exports);
__exportStar(require("./AdminMonitoringApi"), exports);
__exportStar(require("./AdminReferralsApi"), exports);
__exportStar(require("./AdminSportTopPlayersApi"), exports);
__exportStar(require("./AdminStreamingPlatformsApi"), exports);
__exportStar(require("./AdminSubscriptionsApi"), exports);
__exportStar(require("./AdminUsersApi"), exports);
__exportStar(require("./AuthApi"), exports);
__exportStar(require("./BillingWebhooksApi"), exports);
__exportStar(require("./DigestApi"), exports);
__exportStar(require("./DigestsApi"), exports);
__exportStar(require("./FAQsApi"), exports);
__exportStar(require("./LegalApi"), exports);
__exportStar(require("./LocalizationApi"), exports);
__exportStar(require("./LocalizationAdminApi"), exports);
__exportStar(require("./MediaApi"), exports);
__exportStar(require("./NotificationsApi"), exports);
__exportStar(require("./OnboardingApi"), exports);
__exportStar(require("./OtpApi"), exports);
__exportStar(require("./PlayersApi"), exports);
__exportStar(require("./ReferralsApi"), exports);
__exportStar(require("./SpoilerShieldApi"), exports);
__exportStar(require("./SubscriptionsApi"), exports);
__exportStar(require("./TeamsApi"), exports);
__exportStar(require("./UsersApi"), exports);
__exportStar(require("./WaitlistApi"), exports);
__exportStar(require("./WebhooksApi"), exports);
